import { CircularProgress } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BucketCarouselFields from '../../components/createBucketComponents/BucketCarouselFields';
import BucketGridFields from '../../components/createBucketComponents/BucketGridFields';
import { Loader } from '../../components/loader/Loader';
import { GenericPopUp } from '../../components/popup/genericPopUp';
import { uploadImages } from '../../services/bannerServices';
import { fetchAllBuckets, fetchBucketTypeAllOptions, getGridOptionMapping, getUrlParam, updateBucketConfig } from '../../services/manageBucketService';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions';
import { popupType } from '../../types/types';
import { bucketDesigns } from '../createBucket/bucketTypes';
import { bucketType, createBucketNavigate, gridOptionsData, primaryTypeState, secondaryTypesState } from '../createBucket/CreateBucketTypes';
import { defaultBucketConfig } from '../manageBucket/ManageBucketConfig';
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes';
import BackButton from '../../components/Buttons/BackButton/BackButton';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';

function EditBucket() {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as createBucketNavigate;
  const allBuckets = state.buckets;
  const currentBucketLocationData = state.currentBucket;
  const currentBucketRef = useRef(state.currentBucket);
  const primaryType = currentBucketRef.current.primarySource==="pieceSize"? "Pack Size" : currentBucketRef.current.primarySource;
  const [selectedPrimaryTypesState,setSelectedPrimaryTypesState] = useState<primaryTypeState[]>([]);
  const [secondaryTypeOptions,setSecondaryTypeOptions] = useState<string[]>([])
  const secondaryType = currentBucketRef.current.secondarySource==="pieceSize"? "Pack Size" : currentBucketRef.current.secondarySource;
  const [selectedPrimaryTypes,setSelectedPrimaryTypes] = useState<string[]>([]);
  const [primaryTypeOptions,setPrimaryTypeOptions] = useState<string[]>([]);
  const bucketDesign = currentBucketRef.current.bucketDesign;

  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [openGenericModal, setOpenGenericModal] = useState<boolean>(false);
  const [popupMessage, setPopupMessage] = useState<string>("");
  const [showLoader,setShowLoader] = useState<boolean>(false);
  const [showSubmitLoader,setShowSubmitLoader] = useState<boolean>(false);
  const [gridDataMapping,setGridDataMapping] = useState<gridOptionsData[]>([]);
  const bucketConfigurationRef = useRef<any[]>(defaultBucketConfig);
  useEffect(() => {
    async function getAndSetCurrentBucket(){
      const bucketConfig = await fetchAllBuckets();
      if(bucketConfig){
        bucketConfigurationRef.current = bucketConfig;
      }
      let currentBucket = bucketConfigurationRef.current[0].value.find((bucket: any) => {
        return bucket.id === currentBucketLocationData.id;
      })
      if(!currentBucket){
        openPopup("Alert",`Bucket with id: ${currentBucketLocationData.id} has been deleted`,() => {
          window.history.back();
        });
        return;
      }
      if(bucketDesign==="Carousel" || bucketDesign==="1DGrid"){
        const primaryTypesState = currentBucket.primarySourceOptions.map((option: any) => {
          const value = option.name;
          delete option.value;
          return {
              ...option,
              inputRef: null,
              value
          }
      })
      setSelectedPrimaryTypesState(primaryTypesState);
      }else{ // Grid
        // const secondaryType = currentBucket.secondarySource;
        const tempSecondaryTypes = await fetchBucketTypeAllOptions(getUrlParam(secondaryType));
        setSecondaryTypeOptions(tempSecondaryTypes);
        const primaryTypesData = await fetchBucketTypeAllOptions(getUrlParam(primaryType));
        const gridData = await getGridOptionMapping(primaryType,secondaryType,primaryTypesData);
        setGridDataMapping(gridData);
        const primaryTypesState = currentBucket.primarySourceOptions.map((primaryOption: any) => {
          return {
            id: primaryOption.id,
            inputRef: null,
            value: primaryOption.name,
            blobKey: primaryOption.blobKey,
            color: primaryOption.color,
            activeStatus: primaryOption.activeStatus,
            secondaryTypeOptions: primaryOption.secondarySourceOptions.map((secondaryOption:any) => {
              return {
                id: secondaryOption.id,
                inputRef: null,
                value: secondaryOption.name,
                blobKey: secondaryOption.blobKey,
              }
            }),
            availableSecondaryTypes: gridData.find((gridOption: gridOptionsData) => {
              return gridOption.name === primaryOption.name;
            })?.secondaryOptions?.filter((secondaryOptionName: string) => {
              return primaryOption.secondarySourceOptions.findIndex((secondaryOption: any) => secondaryOption.name === secondaryOptionName) === -1
            }) || [],
            selectedSecondaryTypes: [],
          }
        })
        setSelectedPrimaryTypesState(primaryTypesState);
      }
      
      setShowLoader(false);
    }
    setShowLoader(true);
    getAndSetCurrentBucket();
  },[])
  const validateEditBucketFields = () => {
    let invalidCount = 0;
    let message = "";
    if (bucketDesign === "Carousel" || bucketDesign==="1DGrid") {
      if (invalidCount < 1 && selectedPrimaryTypesState.length === 0) {
        message = "Please select and add atleast one " + primaryType;
        invalidCount++;
      } else if (invalidCount < 1 && selectedPrimaryTypesState.length > 0) {
        let carouselImageInvalidCount = 0;
        for (let num = 0; num < selectedPrimaryTypesState.length; num++) {
          if (selectedPrimaryTypesState[num]) {
            const caraouselItem = selectedPrimaryTypesState[num];
            if (
                carouselImageInvalidCount < 1 &&
              (!caraouselItem.inputRef || !caraouselItem.inputRef.files?.[0]) &&
              !caraouselItem.blobKey
            ) {
              message = "Please add images for all Grid items, or remove unnecessary items"; 
              carouselImageInvalidCount++;
            }
            else if(carouselImageInvalidCount>1){
                break;
            }
          }
        }
      }
    } else if (bucketDesign === "Grid") {
      if (invalidCount < 1 && !secondaryType) {
        message = "Please select a Bucket Sub-Type";
      }
      let gridImageInvalidCount = 0;
      for(let pIdx=0;pIdx<selectedPrimaryTypesState.length;pIdx++){
        const primaryItem = selectedPrimaryTypesState[pIdx];
        if(gridImageInvalidCount<1 && (!primaryItem.inputRef || !primaryItem.inputRef.files?.[0]) && !primaryItem.blobKey){
            message = "Please add images for all 2D Grid items, or remove unnecessary items";
            gridImageInvalidCount++;
        }else if(gridImageInvalidCount>1){
            break;
        }
        if(primaryItem.secondaryTypeOptions){
            const secondaryItems = primaryItem.secondaryTypeOptions;
            for(let sIdx=0;sIdx<secondaryItems.length;sIdx++){
                const secondaryItem = secondaryItems[sIdx];
                if(gridImageInvalidCount<1 && (!secondaryItem.inputRef || !secondaryItem.inputRef.files?.[0]) && !secondaryItem.blobKey){
                    message = "Please add images for all 2D Grid items, or remove unnecessary items";
                    gridImageInvalidCount++;
                }else if(gridImageInvalidCount>1){
                    break;
                }
            }
        }
      }
    }
    return invalidCount < 2
      ? message
      : "Multiple Fields are invalid, please fill all the required fields to continue";
  }
  const handleBucketUpdate = async () => {
      try{
        const currentBucket = currentBucketRef.current;
        setShowSubmitLoader(true);
        const validationMessage = validateEditBucketFields();
        if (validationMessage !== "") {
          setShowSubmitLoader(false);
          setPopupMessage(validationMessage);
          setPopupType("Alert");
          setOpenGenericModal(true);
          return;
        }
        const imagesPayload = new FormData();
        const allBuckets = bucketConfigurationRef.current[0].value as any[];
        let newAllBuckets = [...allBuckets]
        const bucketIdx = allBuckets.findIndex(
          (bucket) => bucket.id === currentBucket.id
        );
        if(bucketDesign==="Carousel" || bucketDesign==="1DGrid"){
          for (let num = 0; num < selectedPrimaryTypesState.length; num++) {
            const caraouselItem = selectedPrimaryTypesState[num];
            if (caraouselItem.inputRef?.files?.[0])
              imagesPayload.append("files", caraouselItem.inputRef?.files?.[0]);
          }
          const blobUrls = imagesPayload.has("files")
            ? await uploadImages(imagesPayload)
            : [];
          if (!Array.isArray(blobUrls)) {
            setOpenGenericModal(true);
            setShowSubmitLoader(false);
            setPopupMessage(blobUrls.message);
            setPopupType("Error");
            return;
          }
          let blobIdx = 0;
          const primarySourceOptions = selectedPrimaryTypesState.map(
            (carouselItem: primaryTypeState) => {
              return {
                id: carouselItem.id,
                name: carouselItem.value,
                blobKey: carouselItem.blobKey || blobUrls[blobIdx++],
              };
            }
          );
          const newBucketPayload: any = {
            ...currentBucket,
            primarySourceOptions,
          };
          
          newAllBuckets[bucketIdx] = newBucketPayload;
          
        }else if(bucketDesign==="Grid"){
          for (
            let primaryIdx = 0;
            primaryIdx < selectedPrimaryTypesState.length;
            primaryIdx++
          ) {
            const primaryTypeOption = selectedPrimaryTypesState[primaryIdx];
            if (primaryTypeOption.inputRef?.files?.[0]) {
              imagesPayload.append("files", primaryTypeOption.inputRef.files[0]);
            }
            const secondaryTypeOptions = primaryTypeOption.secondaryTypeOptions;
            if (secondaryTypeOptions) {
              for (
                let secondaryIdx = 0;
                secondaryIdx < secondaryTypeOptions.length;
                secondaryIdx++
              ) {
                const secondaryTypeOption = secondaryTypeOptions[secondaryIdx];
                if (secondaryTypeOption.inputRef?.files?.[0]) {
                  imagesPayload.append(
                    "files",
                    secondaryTypeOption.inputRef.files[0]
                  );
                }
              }
            }
          }
          const blobUrls = imagesPayload.has("files")
            ? await uploadImages(imagesPayload)
            : [];
          if (!Array.isArray(blobUrls)) {
            setShowSubmitLoader(false);
            setOpenGenericModal(true);
            setPopupMessage(blobUrls.message);
            setPopupType("Error");
            return;
          }
          let blobIdx = 0;
          const primarySourceOptions = selectedPrimaryTypesState.map(
            (gridItem: primaryTypeState) => {
              return {
                id: gridItem.id,
                name: gridItem.value,
                blobKey: gridItem.inputRef?.files?.[0]
                  ? blobUrls[blobIdx++]
                  : gridItem.blobKey,
                activeStatus: gridItem.activeStatus,
                color: gridItem.color,
                secondarySourceOptions: gridItem.secondaryTypeOptions!.map(
                  (gridSecondaryItem: secondaryTypesState) => {
                    return {
                      id: gridSecondaryItem.id,
                      name: gridSecondaryItem.value,
                      blobKey: gridSecondaryItem.inputRef?.files?.[0]
                        ? blobUrls[blobIdx++]
                        : gridSecondaryItem.blobKey,
                    };
                  }
                ),
              };
            }
          );
          const newBucketPayload: any = {
            ...currentBucket,
            primarySourceOptions,
          };
          newAllBuckets[bucketIdx] = newBucketPayload;
        }
        const newBucketConfiguration = [...bucketConfigurationRef.current];
        newBucketConfiguration[0].value = newAllBuckets;
        let finalRequestBody = {
          domainName: "clientconfig",
          domainType: "bucket_configuration",
          domainValues: newBucketConfiguration,
          lob: JSON.parse(localStorage.authContext).user.lob,
        }
        validateWithOtp((verifiedUser?: manageUpdateAccessObj)=>{doFinalBucketUpdate(finalRequestBody,verifiedUser)})
       
      }catch(err){
        setShowSubmitLoader(false);
        setPopupMessage(`Something went wrong, Please try again`);
        setPopupType("Error");
        setOpenGenericModal(true);
      }
  }

  const doFinalBucketUpdate=async (finalRequestBody:Object,verifiedUser?: manageUpdateAccessObj)=>{
    try {
      const response = await updateBucketConfig(
        finalRequestBody,
        "bucket_configuration",
        verifiedUser
      );
      setShowSubmitLoader(false);
      if (response.status === 200 || response.status === 201) {
        setPopupMessage(
          `Bucket with ID: ${currentBucketRef.current.id} updated successfully`
        );
        setPopupType("Success");
        setOpenGenericModal(true);
      } else {
        throw new Error();
      }
    } catch (error) {
          setShowSubmitLoader(false);
          setPopupMessage(`Something went wrong, Please try again`);
          setPopupType("Error");
          setOpenGenericModal(true);
    }
  }
  const renderBucketTypeInputs = () => {
    switch(currentBucketRef.current.bucketDesign){
      case "Carousel": 
      // case "1DGrid": 
      return <BucketCarouselFields bucketTextFieldData={{id: currentBucketRef.current.id,subtitle: currentBucketRef.current.subtitle, title: currentBucketRef.current.title }} view="partialEdit" selectedPrimaryTypes={[]} primaryTypeOptions={[]} primaryType={primaryType} selectedPrimaryTypesState={selectedPrimaryTypesState} setSelectedPrimaryTypesState={setSelectedPrimaryTypesState} />;
      case "Grid": return <BucketGridFields
      gridDataLoader={false}
      gridDataMapping={gridDataMapping}
      view={"partialEdit"} 
      secondaryTypeOptions={secondaryTypeOptions}
      selectedPrimaryTypes={selectedPrimaryTypes}
      setSelectedPrimaryTypes={setSelectedPrimaryTypes}
      setPrimaryTypeOptions={setPrimaryTypeOptions}
      primaryTypeOptions={primaryTypeOptions}
      primaryType={primaryType}
      selectedPrimaryTypesState={selectedPrimaryTypesState}
      setSelectedPrimaryTypesState={setSelectedPrimaryTypesState}
      secondaryType={secondaryType}
    />
    }
  }
  return (
    <>  
         {showLoader? <Loader />:<div className="create-bucket-parent">
            <div className="create-bucket-label">
                <span>{ ("Manage " + primaryType + " " + bucketDesigns.find((option) => option.id === currentBucketRef.current.bucketDesign)?.label )}</span>
                <div className='edit-bucket-header-buttons-container'>
                <button
                    className="create-bucket-label-back-button create-bucket-secondary-color"
                    onClick={() => {
                      const navState: createBucketNavigate = {
                        buckets: allBuckets,
                        currentBucket: currentBucketRef.current,
                        bucketConfiguration: bucketConfigurationRef.current
                      }
                      if(currentBucketRef.current.bucketDesign==="Grid"){
                        navState["gridData"] = gridDataMapping;
                      }
                      navigate("/dashboard/manageBucket/createBucket",{
                          state: navState
                        })
                    }}
                >
                      {translate(TranslationEnum.common_portal,"EDIT")}
                </button>
                <BackButton />
                </div>
            </div>
        {renderBucketTypeInputs()}
        <div className="create-bucket-submit-button-container">
          <button
            onClick={handleBucketUpdate}
            className="create-bucket-submit-button"
          >
            {showSubmitLoader? (
              <div>
                <CircularProgress size={15} color="inherit" />
                <span className="circular-progress-container ">UPDATE</span>
              </div>
            ) : (
              <>UPDATE</>
            )}
          </button>
        </div>
        <GenericPopUp
          type={popupType}
          message={popupMessage}
          setOpenGenericModal={popupType==="Success"?() => {
            setOpenGenericModal(false);
            navigate('/dashboard/manageBucket');
          }: setOpenGenericModal}
          openGenericModal={openGenericModal}
        />
      </div>}
    </>
  )
}

export default EditBucket;